import { createI18n } from 'vue-i18n';

export function setI18nLanguage(locale) {
  if (configI18n.mode === 'legacy') {
    configI18n.global.locale = locale;
  } else {
    configI18n.global.locale.value = locale;
  }

  document.querySelector('html').setAttribute('lang', locale);
  localStorage.setItem('lang', locale);
}

// Import the App locales here.
export function loadLocaleMessages() {
  const nl = import.meta.glob('@/locales/nl/*.json');
  const en = import.meta.glob('@/locales/en/*.json');

  const messages = {};

  for (const path in nl) {
    nl[path]().then((mod) => {
      const locale = { nl: mod.default };
      const key = Object.keys(locale);
      messages[key] = { ...messages[key], ...locale[key] };
    });
  }

  for (const path in en) {
    en[path]().then((mod) => {
      const locale = { en: mod.default };
      const key = Object.keys(locale);
      messages[key] = { ...messages[key], ...locale[key] };
    });
  }
  return messages;
}

let configI18n;
export default function setupI18n() {
  if (!configI18n) {
    // set lang based on html lang attribute
    let htmlLang = document.querySelector('html').getAttribute('lang');
    let locale = localStorage.getItem('lang') || import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'nl';

    if (htmlLang === 'en') {
      locale = 'en';
    } else if (htmlLang === 'nl-NL' || htmlLang === 'nl') {
      locale = 'nl';
    }

    configI18n = createI18n({
      globalInjection: true,
      locale: locale,
      legacy: false,
      warnHtmlMessage: false, // disable warning HTML in message
      fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'nl',
      messages: loadLocaleMessages(),
    });

    setI18nLanguage(locale);
  }
  return configI18n;
}
